import { $, $$ } from '@utils';

const SELECTOR_SIDE = '[data-au-accordion-side]',
  SELECTOR_BTN = '[data-au-accordion-side-btn]',
  SELECTOR_CONTENT = '[data-au-accordion-side-content]',
  SELECTOR_ICON = '[data-au-accordion-side-icon]',
  CLASS = 'au-closed',
  CLASS_ACTIVE = 'au-active';

function init() {
  if (!$(SELECTOR_SIDE)) return;

  $$(SELECTOR_SIDE).forEach((accordion) => {
    const btns = [...accordion.querySelectorAll(SELECTOR_BTN)];
    const isTabPattern = btns.some((btn) => btn.getAttribute('role') === 'tab');

    btns.forEach((btn) => {
      btn.addEventListener('click', () => activateItem(btn));
    });

    if (isTabPattern) {
      setupArrowNavigation(accordion, btns);
    }
  });
}

function activateItem(btn) {
  const accordion = btn.closest(SELECTOR_SIDE);
  const targetId = btn.getAttribute('aria-controls');
  const isTabPattern = btn.getAttribute('role') === 'tab';

  accordion.querySelectorAll(SELECTOR_BTN).forEach((accordionSideBtn) => {
    accordionSideBtn.classList.add(CLASS);
    accordionSideBtn.setAttribute('aria-selected', 'false');
    updateIcon(accordionSideBtn, false);
    if (isTabPattern) accordionSideBtn.setAttribute('tabindex', '-1');
  });

  accordion.querySelectorAll(SELECTOR_CONTENT).forEach((accordionSideContent) => {
    accordionSideContent.classList.add(CLASS);
    accordionSideContent.classList.remove(CLASS_ACTIVE);
  });

  btn.classList.remove(CLASS);
  btn.setAttribute('aria-selected', 'true');
  if (isTabPattern) btn.setAttribute('tabindex', '0');
  updateIcon(btn, true);

  const target = accordion.querySelector(`#${targetId}`);
  if (target) {
    target.classList.remove(CLASS);
    target.classList.add(CLASS_ACTIVE);
  }
}

function setupArrowNavigation(accordion, btns) {
  btns.forEach((btn) => {
    btn.addEventListener('keydown', (e) => {
      const currentIndex = btns.indexOf(document.activeElement);
      if (currentIndex === -1) return;

      let nextIndex = -1;

      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        nextIndex = (currentIndex + 1) % btns.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        nextIndex = (currentIndex - 1 + btns.length) % btns.length;
      } else if (e.key === 'Home') {
        e.preventDefault();
        nextIndex = 0;
      } else if (e.key === 'End') {
        e.preventDefault();
        nextIndex = btns.length - 1;
      }

      if (nextIndex !== -1) {
        activateItem(btns[nextIndex]);
        btns[nextIndex].focus();
      }
    });
  });
}

function updateIcon(btn, active) {
  const icon = btn.querySelector(SELECTOR_ICON);
  if (!icon) return;

  const iconName = active ? btn.getAttribute('data-au-icon-active') : btn.getAttribute('data-au-icon-inactive');
  if (iconName) icon.textContent = iconName;
}

export default { init };
